export function deriveWarehouseRouteKey(args: {
  isAllMode: boolean;
  activeWarehouseId: string | null | undefined;
}): string {
  return args.isAllMode ? '__all__' : (args.activeWarehouseId ?? '__none__');
}
